module.exports = __webpack_public_path__ + "static/media/sample2.8c394a97.jpg";